import { DataClass, DataItem } from 'scrivito'

import { showUnlinkToast } from '@/Atomic/Widgets/Toasts/UnlinkToast'
import {
  DataItemFromRelationGetter,
  RelationCreate,
} from '@/utils/CRUD/read/relational/types'
import { DataBinary } from '@/utils/dataBinaryToUrl'
import { getDataItemInitials } from '@/utils/dataClassMap'
import { getDataItem } from '@/utils/getDataItem'
import { getDataClassIcon } from '@/utils/image/getDataClassIcon'
import { isString } from '@/utils/isString'

export const getDataItemFromConnection = (
  connection: DataItem,
  getter: DataItemFromRelationGetter,
) => {
  const dataItemId = connection.get(getter.get)

  if (isString(dataItemId)) {
    return getDataItem(getter.dataClass, dataItemId)
  }
}

export const mapSublistItem = (dataItem: DataItem, connection?: DataItem) => {
  const map = {
    id: dataItem.id(),
    title: dataItem.get('name') as string,
    subtitle: dataItem.get('email') as string,
    image: dataItem.get('image') as DataBinary,
    avatarIcon: getDataClassIcon(dataItem.dataClassName() ?? ''),
    initials: getDataItemInitials(dataItem),
    dataItem: dataItem,
    connection: connection,
  }

  return map
}

export const createRelation = (
  relationDataClass: DataClass,
  setter: RelationCreate,
  src: string,
  dist: string,
) => {
  return relationDataClass.create({
    [setter.src]: src,
    [setter.dist]: dist,
  })
}

export const linkDataItem =
  (relationDataClass: DataClass, setter: RelationCreate, src: string) =>
  (id: string) => {
    return createRelation(relationDataClass, setter, src, id)
  }

interface UnLinkDataItemArgs {
  relationDataItem?: DataItem
  removedListItem?: DataItem
  onError?: () => void
  onUndo?: () => void
}

export const unLinkDataItem = ({
  relationDataItem,
  removedListItem,
  onError,
  onUndo,
}: UnLinkDataItemArgs) => {
  if (!relationDataItem) return

  showUnlinkToast({
    dataItem: removedListItem,
    onCommit: () => relationDataItem.delete(),
    onError,
    onUndo,
  })
}
